import { useAuthStore } from "~/stores/useAuthStore";
type ApiResponseUserContracts = {
    data:{
        contracts:IContract[]
    }
}
export async function useContract(){
    const contracts = ref<ApiResponseUserContracts | null>(null);
    try {
        const auth = useAuthStore();
        const data = await auth.useAuthApiFetchClient<ApiResponseUserContracts>('/api/user/contracts');
        contracts.value = data;
    } catch (error) {
        useNuxtApp().$apiError();
    }
    return{ contracts: contracts.value?.data.contracts || []}

}
